import React from "react"
import { graphql, Link } from 'gatsby'
// import Img from 'gatsby-image'
import Imgix from 'react-imgix'
import Sider from '../components/sider'
import Layout from '../components/layout'
import Seo from '../components/seo'

const CatTemplate = ({ data, location, pageContext }) => {
  const title = pageContext.currentPage === 1 ? `「${pageContext.tagname}」についての記事 | KameWalk` : `「${pageContext.tagname}」についての記事 ページ${pageContext.currentPage} | KameWalk`

  return (
    <Layout>
      <Seo
        pagetitle={title}
        pagedesc={`「${pageContext.tagname}」についての記事です`}
        pagepath={location.pathname}
      />
      <h1 className="catName">「{pageContext.tagname}」についての記事</h1>
      <section className="catContent">
        {data.allMicrocmsBlog.edges.map(({ node }) => (
          <article key={node.id}>
            <Link to={`/post/${node.slug}/`} className="title"><h3>{node.title}</h3></Link>
            <div className="dateLabel">
              <div className="date">
                <time dateTime={node.publishDate}>{node.publishDateJP}</time>
              </div>
              <div className="label">
                <ul className="tags">
                  {node.category.map(cat => (
                    <li className={`${cat.categorySlug} tag`} key={cat.id}>
                      <Link to={`/tag/${cat.categorySlug}/`}>{cat.category}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <Link to={`/post/${node.slug}/`}>
              <figure>
                <Imgix
                  src={node.eyecatch.url}
                  htmlAttributes={{
                    alt: ``,
                  }}
                />
              </figure>
            </Link>
            <div className="desc">{node.description}</div>
          </article>
        ))}
        <ul className="page">
          <li className="pagenation">
            {!pageContext.isFirst && (
              <Link to={pageContext.currentPage === 2 ? `/tag/${pageContext.tagslug}/` :`/tag/${pageContext.currentPage - 1}/`} rel='prev'>
                <span>前のページ</span>
              </Link>
            )}
          </li>
          <li className="pagenation">
            {!pageContext.isLast && (
              <Link to={`/tag/${pageContext.tagslug}/${pageContext.currentPage + 1}/`} rel='next'>
                <span>次のページ</span>
              </Link>
            )}
          </li>
        </ul>
      </section>
      <Sider/>
    </Layout>
  )
}
export default CatTemplate;
export const query = graphql`
  query($tagid: String!, $skip: Int!, $limit: Int!) {
    allMicrocmsBlog(
      sort: { order: DESC, fields: publishDate }
      skip: $skip
      limit: $limit
      filter: { category: { elemMatch: { id: { eq: $tagid } } } }
    ) {
      edges {
        node {
          title
          id
          slug
          description
          publishDateJP: publishDate(formatString: "YYYY年MM月DD日")
          publishDate
          category {
            category
            categorySlug
            id
          }
          eyecatch {
            url
          }
        }
      }
    }
  }
`